(() => {
  'use strict';

  const updateFooterState = (footer) => {
    footer.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  };

  const initFooterProtection = () => {
    const footer = document.querySelector('[data-mh-site-footer]');
    if (!footer) return;
    updateFooterState(footer);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          document.body.classList.toggle('mh-footer-in-view', entries.some((entry) => entry.isIntersecting));
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
      );
      observer.observe(footer);
    }
  };

  const initHeader = () => {
    const header = document.querySelector('[data-mh-site-header]');
    if (!header) return;
    const menu = header.querySelector('.mh-site-header__mobile-menu');
    if (!menu) return;

    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        const trigger = menu.querySelector(':scope > summary');
        if (trigger) trigger.focus();
      }
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.mh-site-header__cart span').forEach((count) => {
        count.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
      });
      document.querySelectorAll('.mh-site-header__cart').forEach((link) => {
        link.setAttribute('aria-label', `Cart with ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
      });
    } catch (error) {
      // The cart link still works as a reliable no-JavaScript fallback.
    }
  };

  const init = () => {
    initHeader();
    initFooterProtection();
    document.addEventListener('mh:cart-added', refreshCartCount);
    document.addEventListener('cart:updated', refreshCartCount);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
